import { ConvertedRealEstate } from '../../../../../@types/real-estate-api-types'
import { useMemo } from 'react'
import _ from 'lodash'

export function useGroupedObjects(objects: ConvertedRealEstate[]) {
  return useMemo(() => {
    return _.groupBy(
      objects,
      (object) =>
        `${object.listing.street}-${object.listing.houseNumber}-${object.listing.postcode}-${object.listing.city}`
    )
  }, [objects])
}
